import { useEffect, useMemo, useRef, useState } from "react";
import {Sheet} from "react-modal-sheet";
import "./style.css"
import { X } from "lucide-react";
import { useTheme } from "../../global-components/src";

interface Props{
    children: React.ReactNode
    open: boolean
    hasXClose?: boolean
    initialSnap?: number
    disableDrag?: boolean
    snapPoints?: Array<number>
    title?: React.ReactNode
    setOpen: (open: boolean) => void
} 

export default function BottomSheet({ children, open, snapPoints = [1], title, disableDrag=false, hasXClose=false, initialSnap=1, setOpen }: Props) {
  const [currentSnap, setCurrentSnap] = useState(initialSnap);
  const { isDarkMode } = useTheme();
  const firstRun = useRef(true);
  const [isAtTop, setIsAtTop] = useState(false);
  const statusbarStyleClose = useMemo(() => (window.location.pathname === "/" || (window.location.pathname.includes("@") && !window.location.pathname.includes("chat"))) && isAtTop ? (isDarkMode ? "#181818" : "#F4F2EE") : (isDarkMode ? "#000" : "#fff"), [isAtTop, window.ReactNativeWebView, window.ReactNativeWebView?.postMessage, window.innerWidth, window.location.pathname, isDarkMode]);
    
    useEffect(() => {
          setIsAtTop(true);
          const handleScroll = () => {
              setIsAtTop(window.scrollY < 40); // considera "no topo" se scroll for menor que 10px
          };
  
          window.addEventListener("scroll", handleScroll);
          return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isAllOpen = useMemo(() => {
    return currentSnap >= snapPoints.length - 1;
  }, [currentSnap, snapPoints]);

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false; // ignora a primeira execução
      return;
    }

      if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
        window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: open && ((!isAllOpen && !disableDrag ) || (disableDrag && snapPoints.length > 2)) ? (isDarkMode ? "#000" : statusbarStyleClose && (window.location.pathname === "/" || (window.location.pathname.includes("@") && !window.location.pathname.includes("chat"))) && isAtTop  ? "#92918f" : "#999999"): (isAllOpen ? (isDarkMode ? "#000" : "#fff") : statusbarStyleClose) }));
      }
  }, [isAllOpen, currentSnap, open]);

  return (
    <>
      <Sheet dragVelocityThreshold={500} initialSnap={initialSnap} disableDrag={disableDrag} isOpen={open} onSnap={(snap) => {  setCurrentSnap(snap); }} snapPoints={snapPoints} onClose={() => setOpen(false)}>
        <Sheet.Container className={(!isAllOpen && !disableDrag ) || (disableDrag && snapPoints.length > 2)  ? "react-modal-sheet-container-border-radius" : ""}>
          {title}
          {!disableDrag ? (
            <Sheet.Header />
          ) : null}

          <Sheet.Content>
            {hasXClose ? (
              <div style={{ height: 25, width: 25, position: "absolute", right: 10, top: 10, opacity: .3, display: "flex", justifyContent: "center", alignItems: "center", padding: 0, zIndex: 9 }}>
                <X style={{  }} onClick={() => setOpen(false)}/>
              </div>
            ) : null }
            {children}
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={() => setOpen(false)} />
      </Sheet>
    </>
  );
}

